


const SIXTEEN_HOURS = 16 * 60 * 60 * 1000;

export const loadState = () => {
    try {
      const timestamp = localStorage.getItem('reduxStateTimestamp');
      if (timestamp && Date.now() - Number(timestamp) > SIXTEEN_HOURS) {
        localStorage.removeItem('reduxState');
        localStorage.removeItem('reduxStateTimestamp');
        return undefined;
      }
      const serializedState = localStorage.getItem('reduxState');
      if (serializedState === null) {
        return undefined;
      }
      return JSON.parse(serializedState);
    } catch (err) {
      console.error("Could not load state", err);
      return undefined;
    }
  };

  export const saveState = (state) => {
    try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem('reduxState', serializedState);
      localStorage.setItem('reduxStateTimestamp', Date.now().toString());
    } catch (err) {
      console.error("Could not save state", err);
    }
  };